var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVCisoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.577,
    height: 16.587,
    viewBox: "0 0 18.577 16.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_183",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 183",
    transform: "translate(1734.18 5200.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_60",
    "data-name": "\\u30D1\\u30B9 60",
    d: "M-1720.2-5185.345l-4.688,2.793-4.688-2.793-3.791,2.793,8.479,7.082,8.479-7.082Z",
    transform: "translate(0 -9.472)",
    fill: "none",
    stroke: "#4477c0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_182",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 182",
    transform: "translate(-1732.565 -5200.379)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5",
    "data-name": "\\u6955\\u5186\\u5F62 5",
    cx: 1.862,
    cy: 1.862,
    r: 1.862,
    transform: "translate(5.773 2.236)",
    fill: "none",
    stroke: "#4477c0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_6",
    "data-name": "\\u6955\\u5186\\u5F62 6",
    cx: 1.862,
    cy: 1.862,
    r: 1.862,
    transform: "translate(0)",
    fill: "none",
    stroke: "#4477c0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_7",
    "data-name": "\\u6955\\u5186\\u5F62 7",
    cx: 1.862,
    cy: 1.862,
    r: 1.862,
    transform: "translate(11.622)",
    fill: "none",
    stroke: "#4477c0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCisoLogo);
export default __webpack_public_path__ + "static/media/vCISO_logo.11e5ee379abfcae1d584b735d4a57529.svg";
export { ForwardRef as ReactComponent };